import React from "react";

const Inbox = () => {

  return (
    <React.Fragment>
      <div>
        <section>
            <div style={{textAlign:'center', padding:'10%'}}>
          <h2>Your inbox</h2>
            <h4>Click to view a message thread.
            </h4>
            </div>
         
        </section>
      </div>
    </React.Fragment>
  );
};

export default Inbox;
